import { render, staticRenderFns } from "./DonutChartProgresso.vue?vue&type=template&id=65f7bbc9&"
import script from "./DonutChartProgresso.vue?vue&type=script&lang=js&"
export * from "./DonutChartProgresso.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartProgresso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports